module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/iPhone-X-02447b3b0bb6a149fba35fa0162d5ace.svg";